<template>
  <div>
    <!-- debut dialog -->
    <v-dialog v-model="dialog" max-width="80%" @click:outside="close">
      <template v-slot:activator="{ on }">
        <v-layout
          class="btn-dialog"
          align-start
          justify-end
          v-show="
            !$storeBourse.DonneesFormulaireEC.listeSituationsFamiliale ||
            $storeBourse.DonneesFormulaireEC.listeSituationsFamiliale.filter(
              (item) => {
                return (
                  item.supprimer == false &&
                  item.tuteur == $storeCatalogue.DataId.Oui
                );
              }
            ).length < 3
          "
        >
          <v-btn
            dark
            v-on="on"
            v-show="!$storeBourse.DonneesFormulaireEC.readOnly"
            color="ecSecondary"
            @click="Ajouter"
          >
            {{ $storeUm6p.Label.Ajouter }}
          </v-btn>
        </v-layout>
      </template>
      <v-form ref="form" v-model="valid">
        <v-card>
          <v-toolbar color="ecSecondary" dark>
            <v-toolbar-title>{{ $storeUm6p.Label.Ajouter }}</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-row>
              <v-col cols="6">
                <v-autocomplete
                  :label="$storeUm6p.Label.Parents.LienParental"
                  v-model="$storeBourse.editedItem.parente"
                  :item-text="$storeCommun.ItemLang"
                  item-value="id"
                  :items="$storeCatalogue.Parente"
                  clearable
                  :rules="$storeReglesBourse.obligatoire"
                  :readonly="$storeBourse.DonneesFormulaireEC.readOnly"
                  @change="parenteChange"
                  class="asterisk"
                />
              </v-col>
              <v-col cols="6">
                <v-autocomplete
                  :label="$storeUm6p.Label.Parents.SituationFamiliale"
                  v-model="$storeBourse.editedItem.statutParentTuteur"
                  :item-text="$storeCommun.ItemLang"
                  item-value="id"
                  :items="$storeCatalogue.StatutParentTuteurAffiche"
                  clearable
                  :rules="$storeReglesBourse.obligatoire"
                  :readonly="$storeBourse.DonneesFormulaireEC.readOnly"
                  @change="statutParentTuteurChange"
                  class="asterisk"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6"> </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <v-autocomplete
                  :label="$storeUm6p.Label.Parents.Tuteur"
                  v-model="$storeBourse.editedItem.tuteur"
                  :item-text="$storeCommun.ItemLang"
                  item-value="id"
                  :items="$storeCatalogue.OuiNon"
                  :clearable="!IsReadOnlyTuteur"
                  :rules="
                    $storeBourse.editedItem.statutParentTuteur !=
                    $storeCatalogue.SituationFamDecede
                      ? $storeReglesBourse.obligatoire
                      : []
                  "
                  v-show="
                    $storeBourse.editedItem.statutParentTuteur !=
                    $storeCatalogue.SituationFamDecede
                  "
                  :readonly="IsReadOnlyTuteur"
                  class="asterisk"
                />
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-model="$storeBourse.editedItem.lienParenteTuteur"
                  v-show="
                    $storeBourse.editedItem.parente ==
                    $storeCatalogue.DataId.ParenteTuteur
                  "
                  :rules="
                    $storeBourse.editedItem.parente ==
                    $storeCatalogue.DataId.ParenteTuteur
                      ? $storeReglesBourse.obligatoire
                      : []
                  "
                  :readonly="$storeBourse.DonneesFormulaireEC.readOnly"
                  :label="$storeUm6p.Label.Parents.LienParenteTuteur"
                  class="asterisk"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <v-text-field
                  v-model="$storeBourse.editedItem.nom"
                  :rules="$storeReglesBourse.obligatoire"
                  :readonly="$storeBourse.DonneesFormulaireEC.readOnly"
                  :label="$storeUm6p.Label.Parents.Nom"
                  class="asterisk"
                />
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-model="$storeBourse.editedItem.prenom"
                  :rules="$storeReglesBourse.obligatoire"
                  :readonly="$storeBourse.DonneesFormulaireEC.readOnly"
                  :label="$storeUm6p.Label.Parents.Prenom"
                  class="asterisk"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <v-autocomplete
                  :label="$storeUm6p.Label.Parents.Civilite"
                  v-model="$storeBourse.editedItem.civilite"
                  :item-text="$storeCommun.ItemLang"
                  item-value="id"
                  :items="$storeCatalogue.Civilite"
                  clearable
                  :readonly="$storeBourse.DonneesFormulaireEC.readOnly"
                  :rules="$storeReglesBourse.obligatoire"
                  class="asterisk"
                />
              </v-col>
              <v-col cols="6">
                <v-autocomplete
                  :label="$storeUm6p.Label.Parents.Nationalite"
                  v-model="$storeBourse.editedItem.nationalite"
                  :item-text="$storeCommun.ItemLang"
                  item-value="id"
                  :items="$storeCatalogue.Pays"
                  clearable
                  :readonly="$storeBourse.DonneesFormulaireEC.readOnly"
                  :rules="$storeReglesBourse.obligatoire"
                  class="asterisk"
                />
              </v-col>
            </v-row>
            <div
              v-show="
                $storeBourse.editedItem.statutParentTuteur !=
                $storeCatalogue.SituationFamDecede
              "
            >
              <v-row>
                <v-col cols="6">
                  <v-text-field
                    v-model="$storeBourse.editedItem.cni"
                    :label="
                      $storeBourse.editedItem.nationalite ===
                      $storeCatalogue.DataId.Maroc
                        ? $storeUm6p.Label.Parents.Cni
                        : $storeUm6p.Label.Parents.AutreCni
                    "
                    :rules="Obligatoire ? $storeReglesBourse.obligatoire : []"
                    :readonly="$storeBourse.DonneesFormulaireEC.readOnly"
                    :class="Obligatoire ? 'asterisk' : ''"
                  />
                </v-col>
                <v-col cols="6"></v-col>
              </v-row>
              <v-row>
                <v-col cols="6">
                  <v-text-field
                    v-model="$storeBourse.editedItem.tel"
                    :label="$storeUm6p.Label.Parents.Portable"
                    :rules="
                      Obligatoire ? $storeReglesBourse.telephoneObligatoire : []
                    "
                    :readonly="$storeBourse.DonneesFormulaireEC.readOnly"
                    :class="Obligatoire ? 'asterisk' : ''"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    v-model="$storeBourse.editedItem.email"
                    :rules="
                      Obligatoire ? $storeReglesBourse.emailObligatoire : []
                    "
                    :readonly="$storeBourse.DonneesFormulaireEC.readOnly"
                    :label="$storeUm6p.Label.Parents.AdresseElectronique"
                    :class="Obligatoire ? 'asterisk' : ''"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6">
                  <v-text-field
                    v-model="$storeBourse.editedItem.telFixe"
                    :label="$storeUm6p.Label.Parents.Fixe"
                    :readonly="$storeBourse.DonneesFormulaireEC.readOnly"
                    :rules="$storeReglesBourse.telephone"
                  />
                </v-col>
                <v-col cols="6"> </v-col>
              </v-row>
              <v-row>
                <v-col cols="6">
                  <v-autocomplete
                    :label="$storeUm6p.Label.Parents.SituationHandicap"
                    v-model="$storeBourse.editedItem.situationHandicap"
                    :item-text="$storeCommun.ItemLang"
                    item-value="id"
                    :items="$storeCatalogue.OuiNon"
                    clearable
                    :readonly="$storeBourse.DonneesFormulaireEC.readOnly"
                    :rules="Obligatoire ? $storeReglesBourse.obligatoire : []"
                    :class="Obligatoire ? 'asterisk' : ''"
                    @change="SituationHandicapChange"
                  />
                </v-col>
                <v-col cols="6">
                  <v-autocomplete
                    v-show="
                      $storeBourse.editedItem.situationHandicap ==
                      $storeCatalogue.DataId.Oui
                    "
                    :label="$storeUm6p.Label.Parents.TypeHandicap"
                    v-model="$storeBourse.editedItem.natureHandicap"
                    :item-text="$storeCommun.ItemLang"
                    item-value="id"
                    :items="$storeCatalogue.NatureHandicap"
                    :rules="
                      Obligatoire &&
                      $storeBourse.editedItem.situationHandicap ==
                        $storeCatalogue.DataId.Oui
                        ? $storeReglesBourse.obligatoire
                        : []
                    "
                    clearable
                    :readonly="$storeBourse.DonneesFormulaireEC.readOnly"
                    multiple
                    :class="
                      Obligatoire &&
                      $storeBourse.editedItem.situationHandicap ==
                        $storeCatalogue.DataId.Oui
                        ? 'asterisk'
                        : ''
                    "
                  />
                </v-col>
              </v-row>
              <v-divider></v-divider>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="$storeBourse.editedItem.adressePermanente"
                    :label="$storeUm6p.Label.Parents.AdressePermanante"
                    :readonly="$storeBourse.DonneesFormulaireEC.readOnly"
                    :rules="Obligatoire ? $storeReglesBourse.obligatoire : []"
                    :class="Obligatoire ? 'asterisk' : ''"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6">
                  <v-autocomplete
                    :label="$storeUm6p.Label.Candidat.PaysMaroc"
                    v-model="$storeBourse.editedItem.pays"
                    :item-text="$storeCommun.ItemLang"
                    item-value="id"
                    :items="$storeCatalogue.Pays"
                    :readonly="$storeBourse.DonneesFormulaireEC.readOnly"
                    :rules="Obligatoire ? $storeReglesBourse.obligatoire : []"
                    :class="Obligatoire ? 'asterisk' : ''"
                  />
                </v-col>
                <v-col cols="6"></v-col>
              </v-row>
              <v-row
                v-if="
                  $storeBourse.editedItem.pays == $storeCatalogue.DataId.France
                "
              >
                <v-col cols="6">
                  <v-autocomplete
                    :label="$storeUm6p.Label.Candidat.DepartementFrance"
                    v-model="$storeBourse.editedItem.departementFrance"
                    :item-text="$storeCommun.ItemLang"
                    item-value="id"
                    :items="$storeCatalogue.DepartementFrance"
                    clearable
                    @change="departementChange"
                    :readonly="$storeBourse.DonneesFormulaireEC.readOnly"
                    :rules="Obligatoire ? $storeReglesBourse.obligatoire : []"
                    :class="Obligatoire ? 'asterisk' : ''"
                  />
                </v-col>
                <v-col cols="6">
                  <v-autocomplete
                    :label="$storeUm6p.Label.Candidat.RegionFrance"
                    v-model="$storeBourse.editedItem.regionFrance"
                    :item-text="$storeCommun.ItemLang"
                    item-value="id"
                    :items="$storeCatalogue.RegionFrance"
                    :readonly="$storeBourse.DonneesFormulaireEC.readOnly"
                    disabled
                  />
                </v-col>
              </v-row>
              <v-row
                v-else-if="
                  $storeBourse.editedItem.pays == $storeCatalogue.DataId.Maroc
                "
              >
                <v-col cols="6">
                  <v-autocomplete
                    v-if="
                      $storeBourse.editedItem.pays ==
                      $storeCatalogue.DataId.Maroc
                    "
                    :label="$storeUm6p.Label.Candidat.ProvinceMaroc"
                    v-model="$storeBourse.editedItem.provinceMaroc"
                    :item-text="$storeCommun.ItemLang"
                    item-value="id"
                    :items="$storeCatalogue.Province"
                    clearable
                    @change="provinceChange"
                    :readonly="$storeBourse.DonneesFormulaireEC.readOnly"
                    :rules="Obligatoire ? $storeReglesBourse.obligatoire : []"
                    :class="Obligatoire ? 'asterisk' : ''"
                  />
                </v-col>
                <v-col cols="6">
                  <v-autocomplete
                    v-if="
                      $storeBourse.editedItem.pays ==
                      $storeCatalogue.DataId.Maroc
                    "
                    :label="$storeUm6p.Label.Candidat.RegionMaroc"
                    v-model="$storeBourse.editedItem.regionMaroc"
                    :item-text="$storeCommun.ItemLang"
                    item-value="id"
                    :items="$storeCatalogue.Region"
                    disabled
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="$storeBourse.editedItem.adresseSecondaire"
                    :label="$storeUm6p.Label.Parents.AdresseSecondaire"
                  />
                </v-col>
              </v-row>
              <v-divider></v-divider>
              <v-row>
                <v-col cols="6">
                  <v-autocomplete
                    :label="$storeUm6p.Label.Parents.EtatProfessionnel"
                    v-model="$storeBourse.editedItem.situationPro"
                    :item-text="$storeCommun.ItemLang"
                    item-value="id"
                    :items="$storeCatalogue.SituationPro"
                    clearable
                    v-show="ShowSituationPro"
                    :rules="
                      $storeBourse.editedItem.statutParentTuteur !=
                        $storeCatalogue.SituationFamDecede && ShowSituationPro
                        ? $storeReglesBourse.obligatoire
                        : []
                    "
                    @change="situationProChange"
                    :class="
                      $storeBourse.editedItem.statutParentTuteur !=
                        $storeCatalogue.SituationFamDecede && ShowSituationPro
                        ? 'asterisk'
                        : ''
                    "
                  />
                </v-col>
                <v-col
                  cols="6"
                  v-if="
                    $storeBourse.editedItem.situationPro ==
                    $storeCatalogue.SituationProRetraite
                    || ShowRetraiteActif
                  "
                >
                  <v-menu
                    v-model="menu.dateRetraite"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template #activator="{ on, attrs }">
                      <v-text-field
                        clearable
                        v-model="DateRetraiteFormated"
                        :label="$storeUm6p.Label.Parents.DateDepartRetraite"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        @click:clear="
                          $storeBourse.editedItem.dateDepartRetraite = null
                        "
                        :rules="
                          Obligatoire ? $storeReglesBourse.obligatoire : []
                        "
                        :class="Obligatoire ? 'asterisk' : ''"
                      />
                    </template>
                    <v-date-picker
                      v-model="$storeBourse.editedItem.dateDepartRetraite"
                      :min="MinDateRetraite"
                      :max="MaxDateRetraite"
                      :rules="Obligatoire ? $storeReglesBourse.obligatoire : []"
                      @input="menu.dateRetraite = false"
                    />
                  </v-menu>
                </v-col>
              </v-row>
              <v-row v-if="ShowRetraiteActif">
                <v-col cols="12">
                Situation professionnelle avant la date de la retraite.
                <v-spacer></v-spacer>
                <v-divider></v-divider>
                </v-col>
                <v-col cols="6" v-if="ShowSecteur">
                  <v-autocomplete
                    :label="$storeUm6p.Label.Parents.Secteur"
                    v-model="$storeBourse.editedItem.secteurProfessionnelleRetraite"
                    :item-text="$storeCommun.ItemLang"
                    item-value="id"
                    :items="$storeCatalogue.Secteur"
                    clearable
                    @change="secteurActiviteProChange($storeBourse.editedItem.secteurProfessionnelleRetraite, true)"
                    :rules="
                      Obligatoire && ShowSecteur
                        ? $storeReglesBourse.obligatoire
                        : []
                    "
                    :class="Obligatoire && ShowSecteur ? 'asterisk' : ''"
                  />

                </v-col>
                <v-col cols="6">
                  <v-autocomplete
                    :label="$storeUm6p.Label.Parents.Profession"
                    v-model="$storeBourse.editedItem.professionRetraite"
                    :item-text="$storeCommun.ItemLang"
                    item-value="id"
                    :items="$storeCatalogue.Fonction"
                    v-show="ShowProfession($storeBourse.editedItem.secteurProfessionnelleRetraite)"
                    clearable
                    :rules="
                      Obligatoire && ShowProfession($storeBourse.editedItem.secteurProfessionnelleRetraite)
                        ? $storeReglesBourse.obligatoire
                        : []
                    "
                    :class="Obligatoire && ShowProfession($storeBourse.editedItem.secteurProfessionnelleRetraite) ? 'asterisk' : ''"
                  />

                </v-col>
                <v-col cols="6">
                  <v-text-field
                    v-model="$storeBourse.editedItem.employeurRetraite"
                    :label="$storeUm6p.Label.Parents.NomEmployeur"
                    v-show="ShowEmployeur($storeBourse.editedItem.secteurProfessionnelleRetraite)"
                    :rules="
                      Obligatoire && ShowEmployeur($storeBourse.editedItem.secteurProfessionnelleRetraite)
                        ? $storeReglesBourse.obligatoire
                        : []
                    "
                    :class="Obligatoire && ShowEmployeur($storeBourse.editedItem.secteurProfessionnelleRetraite) ? 'asterisk' : ''"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-autocomplete
                    :label="$storeUm6p.Label.Parents.TypeOrganisme"
                    v-model="$storeBourse.editedItem.typeOrganismeRetraite"
                    :item-text="$storeCommun.ItemLang"
                    item-value="id"
                    :items="$storeCatalogue.TypeOrganisme"
                    :clearable="!DisableTypeOrganisme($storeBourse.editedItem.secteurProfessionnelleRetraite)"
                    v-show="ShowTypeOrganismeRetraite"
                    :rules="
                      Obligatoire && ShowTypeOrganismeRetraite
                        ? $storeReglesBourse.obligatoire
                        : []
                    "
                    :class="Obligatoire && ShowTypeOrganismeRetraite ? 'asterisk' : ''"
                    :readonly="DisableTypeOrganisme($storeBourse.editedItem.secteurProfessionnelleRetraite)"
                  />
                </v-col>
                <v-col cols="12">
                Situation professionnelle après la date de la retraite.
                <v-spacer></v-spacer>
                <v-divider></v-divider>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6">
                  <v-autocomplete
                    :label="$storeUm6p.Label.Parents.Secteur"
                    v-model="$storeBourse.editedItem.secteurActivitePro"
                    :item-text="$storeCommun.ItemLang"
                    item-value="id"
                    :items="$storeCatalogue.Secteur"
                    clearable
                    v-show="ShowSecteur"
                    @change="secteurActiviteProChange($storeBourse.editedItem.secteurActivitePro, false)"
                    :rules="
                      Obligatoire && ShowSecteur
                        ? $storeReglesBourse.obligatoire
                        : []
                    "
                    :class="Obligatoire && ShowSecteur ? 'asterisk' : ''"
                  />
                </v-col>
                <v-col cols="6"> </v-col>
              </v-row>
              <v-row>
                <v-col cols="4">
                  <v-autocomplete
                    :label="$storeUm6p.Label.Parents.Profession"
                    v-model="$storeBourse.editedItem.profession"
                    :item-text="$storeCommun.ItemLang"
                    item-value="id"
                    :items="$storeCatalogue.Fonction"
                    v-show="ShowProfession($storeBourse.editedItem.secteurActivitePro)"
                    clearable
                    :rules="
                      Obligatoire && ShowProfession($storeBourse.editedItem.secteurActivitePro)
                        ? $storeReglesBourse.obligatoire
                        : []
                    "
                    :class="Obligatoire && ShowProfession($storeBourse.editedItem.secteurActivitePro) ? 'asterisk' : ''"
                  />
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    v-model="$storeBourse.editedItem.employeur"
                    :label="$storeUm6p.Label.Parents.NomEmployeur"
                    v-show="ShowEmployeur($storeBourse.editedItem.secteurActivitePro)"
                    :rules="
                      Obligatoire && ShowEmployeur($storeBourse.editedItem.secteurActivitePro)
                        ? $storeReglesBourse.obligatoire
                        : []
                    "
                    :class="Obligatoire && ShowEmployeur($storeBourse.editedItem.secteurActivitePro) ? 'asterisk' : ''"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="4">
                  <v-autocomplete
                    :label="$storeUm6p.Label.Parents.TypeOrganisme"
                    v-model="$storeBourse.editedItem.typeOrganisme"
                    :item-text="$storeCommun.ItemLang"
                    item-value="id"
                    :items="$storeCatalogue.TypeOrganisme"
                    :clearable="!DisableTypeOrganisme($storeBourse.editedItem.secteurActivitePro)"
                    v-show="ShowTypeOrganismeActif"
                    :rules="
                      Obligatoire && ShowTypeOrganismeActif
                        ? $storeReglesBourse.obligatoire
                        : []
                    "
                    :class="Obligatoire && ShowTypeOrganismeActif ? 'asterisk' : ''"
                    :readonly="DisableTypeOrganisme($storeBourse.editedItem.secteurActivitePro)"
                  />
                </v-col>
              </v-row>
              <h5 v-if="ShowAmoTadamon">
                {{ $storeUm6p.Label.Parents.AMO_TADAMON }}
              </h5>
              <v-row v-if="ShowAmoTadamon">
                <v-col cols="4">
                  <v-autocomplete
                    label=""
                    v-model="$storeBourse.editedItem.amoTadamon"
                    :item-text="$storeCommun.ItemLang"
                    item-value="id"
                    :items="$storeCatalogue.OuiNon"
                    clearable
                    :rules="Obligatoire ? $storeReglesBourse.obligatoire : []"
                    :class="Obligatoire ? 'asterisk' : ''"
                  />
                </v-col>
              </v-row>
              <v-row
                v-show="
                  $storeBourse.editedItem.amoTadamon ==
                    $storeCatalogue.DataId.Non || !ShowAmoTadamon
                "
              >
                <v-col cols="6">
                  <h5>
                    {{
                      ShowAmoTadamon
                        ? $storeUm6p.Label.Parents.AutreRegimeProtection
                        : $storeUm6p.Label.Parents.RegimeProtection
                    }}
                  </h5>
                  <v-autocomplete
                    label=""
                    v-model="$storeBourse.editedItem.autreRegime"
                    :item-text="$storeCommun.ItemLang"
                    item-value="id"
                    :items="$storeCatalogue.OuiNon"
                    clearable
                    :rules="
                      $storeBourse.editedItem.amoTadamon ==
                        $storeCatalogue.DataId.Non && Obligatoire
                        ? $storeReglesBourse.obligatoire
                        : []
                    "
                    :class="
                      $storeBourse.editedItem.amoTadamon ==
                        $storeCatalogue.DataId.Non && Obligatoire
                        ? 'asterisk'
                        : ''
                    "
                  />
                </v-col>
                <v-col
                  cols="6"
                  v-show="
                    $storeBourse.editedItem.autreRegime ==
                    $storeCatalogue.DataId.Oui
                  "
                >
                  <h5>{{ $storeUm6p.Label.Parents.QuelOrganisme }}</h5>
                  <v-text-field
                    label=""
                    v-model="$storeBourse.editedItem.nomAutreRegime"
                    :rules="
                      Obligatoire &&
                      $storeBourse.editedItem.autreRegime ==
                        $storeCatalogue.DataId.Oui &&
                      $storeBourse.editedItem.amoTadamon ==
                        $storeCatalogue.DataId.Non
                        ? $storeReglesBourse.obligatoire
                        : []
                    "
                    :class="
                      Obligatoire &&
                      $storeBourse.editedItem.autreRegime ==
                        $storeCatalogue.DataId.Oui &&
                      $storeBourse.editedItem.amoTadamon ==
                        $storeCatalogue.DataId.Non
                        ? 'asterisk'
                        : ''
                    "
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6">
                  <h5>{{ $storeUm6p.Label.Parents.BeneficiaireAssurance }}</h5>
                  <v-autocomplete
                    :label="$storeUm6p.Label.Parents.Mutuelle"
                    v-model="$storeBourse.editedItem.mutuelle"
                    :item-text="$storeCommun.ItemLang"
                    item-value="id"
                    :items="$storeCatalogue.OuiNon"
                    :rules="Obligatoire ? $storeReglesBourse.obligatoire : []"
                    clearable
                    :class="Obligatoire ? 'asterisk' : ''"
                  />
                </v-col>
                <v-col cols="6"></v-col>
              </v-row>
              <v-divider></v-divider>
              <v-row>
                <v-col cols="6">
                  <v-autocomplete
                    :label="$storeUm6p.Label.Parents.NombreCompteBancaire"
                    v-model="$storeBourse.editedItem.nombreCompteBancaire"
                    :item-text="$storeCommun.ItemLang"
                    item-value="id"
                    :items="$storeCatalogue.NbCompteBancaire"
                    clearable
                    :rules="Obligatoire ? $storeReglesBourse.obligatoire : []"
                    :class="Obligatoire ? 'asterisk' : ''"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6">
                  <h5>
                    {{ $storeUm6p.Label.Parents.AssocieOuGerantSociete }}
                  </h5>
                  <v-autocomplete
                    label=" "
                    v-model="$storeBourse.editedItem.associeGerant"
                    :item-text="$storeCommun.ItemLang"
                    item-value="id"
                    :items="$storeCatalogue.OuiNon"
                    :rules="Obligatoire ? $storeReglesBourse.obligatoire : []"
                    :class="Obligatoire ? 'asterisk' : ''"
                  />
                </v-col>
                <v-col
                  cols="6"
                  v-show="
                    $storeBourse.editedItem.associeGerant ==
                    $storeCatalogue.DataId.Oui
                  "
                >
                  <h5>
                    {{ $storeUm6p.Label.Parents.PreciserSociete }}
                  </h5>
                  <v-text-field
                    label=""
                    v-model="$storeBourse.editedItem.preciserSociete"
                    :rules="
                      $storeBourse.editedItem.associeGerant ==
                      $storeCatalogue.DataId.Oui
                        ? $storeReglesBourse.obligatoire
                        : []
                    "
                    :class="
                      $storeBourse.editedItem.associeGerant ==
                      $storeCatalogue.DataId.Oui
                        ? 'asterisk'
                        : ''
                    "
                  ></v-text-field>
                </v-col>
              </v-row>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn small dark color="ecSecondary" @click="close">{{
              $storeUm6p.Label.Annuler
            }}</v-btn>
            <v-btn small dark color="ecSecondary" @click="save">{{
              $storeUm6p.Label.Valider
            }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <!-- fin dialog -->
    <!-- Début Liste langues -->
    <v-data-table
      :headers="headers"
      :items="$storeBourse.DonneesFormulaireEC.listeSituationsFamiliale"
      class="elevation-1"
      disable-pagination
      hide-default-footer
    >
      <template v-slot:item="{ item }">
        <tr v-if="!item.supprimer">
          <th class="text-xs-left">
            {{
              $storeCatalogue.AffichageCatalogue(
                $storeCatalogue.Parente,
                item.parente,
                $storeCommun.ItemLang
              )
            }}
          </th>
          <th class="text-xs-left">
            {{
              $storeCatalogue.AffichageCatalogue(
                $storeCatalogue.OuiNon,
                item.tuteur,
                $storeCommun.ItemLang
              )
            }}
          </th>
          <th class="text-xs-left">
            {{
              $storeCatalogue.AffichageCatalogue(
                $storeCatalogue.StatutParentTuteurAffiche,
                item.statutParentTuteur,
                $storeCommun.ItemLang
              )
            }}
          </th>
          <th class="text-xs-left">{{ item.nom }}</th>
          <th class="text-xs-left">{{ item.prenom }}</th>
          <th class="text-xs-left">
            {{
              $storeCatalogue.AffichageCatalogue(
                $storeCatalogue.SituationPro,
                item.situationPro,
                $storeCommun.ItemLang
              )
            }}
          </th>
          <th class="text-xs-left">
            {{
              $storeCatalogue.AffichageCatalogue(
                $storeCatalogue.Secteur,
                item.secteurActivitePro,
                $storeCommun.ItemLang
              )
            }}
          </th>
          <th class="text-xs-left">
            {{
              $storeCatalogue.AffichageCatalogue(
                $storeCatalogue.Fonction,
                item.profession,
                $storeCommun.ItemLang
              )
            }}
          </th>
          <th>
            <v-icon
              small
              class="mr-2"
              @click="editItem(item)"
              v-show="!$storeBourse.DonneesFormulaireEC.readOnly"
              >{{ icons.mdiPencil }}</v-icon
            >
            <v-icon
              small
              @click="deleteItem(item)"
              v-show="!$storeBourse.DonneesFormulaireEC.readOnly"
              >{{ icons.mdiDelete }}</v-icon
            >
          </th>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import moment from "moment";
import { mdiPencil, mdiDelete } from "@mdi/js";
export default {
  components: {},
  data() {
    return {
      menu: {
        dateRetraite: false,
      },
      // Icon importés depuis mdi/js pour les icones d'édition/suppression
      icons: {
        mdiPencil,
        mdiDelete,
      },
      // Réaffecter l'objet global pour forcer la maj en temps réel
      $storeCatalogue: this.$storeCatalogue,
      $storeCommun: this.$storeCommun,
      $storeBourse: this.$storeBourse,
      // dialog pour ouvrir/fermer la popup
      dialog: false,
      // Validation du formulaire
      valid: false,

      // nom des colonnes
      headers: [
        { text: "Parenté", value: "parente" },
        { text: "Tuteur(rice)", value: "tuteur" },
        { text: "Situation familiale", value: "situationfamiliale" },
        { text: "Nom", value: "nom" },
        { text: "Prenom", value: "prenom" },
        // { text: "Numéro CNI", value: "numcni" },
        // { text: "Tel", value: "tel" },
        // { text: "Email", value: "email" },
        { text: "Situation professionelle", value: "situationpro" },
        { text: "Secteur d'activité professionel", value: "secteuractpro" },
        { text: "Profession", value: "profession" },
        // { text: "Employeur", value: "employeur" },
        // { text: "Situation de handicap", value: "situationhandicap" },
        // { text: "Type de handicap", value: "naturehandicap" },
        { text: "", value: "actions", sortable: false },
      ],

      // Item local
      blankItem: {
        autreRevenuDto: {},
        listeBiensImmo: [],
        listeCredits: [],
        listeAnnexesFirsi: [],
      },
      ShowTypeOrganismeRetraite:false,
      ShowTypeOrganismeActif:false,
    };
  },
  computed: {
    Obligatoire() {
      return (
        this.$storeBourse.editedItem.statutParentTuteur !=
        this.$storeCatalogue.SituationFamDecede
      );
    },
    ShowAmoTadamon() {
      return (
        this.$storeBourse.editedItem.nationalite ===
          this.$storeCatalogue.DataId.Maroc &&
        this.$storeBourse.editedItem.secteurActivitePro !=
          this.$storeCatalogue.SecteurSalarie &&
        this.$storeBourse.editedItem.secteurActivitePro !=
          this.$storeCatalogue.SecteurFonctionnaire &&
        this.$storeBourse.editedItem.situationPro !=
          this.$storeCatalogue.SituationProRetraite
      );
    },
    ShowSecteur() {
      return !(
        this.$storeBourse.editedItem.situationPro ==
          this.$storeCatalogue.SituationProNonActif ||
        (this.$storeBourse.editedItem.statutParentTuteur ==
          this.$storeCatalogue.SituationFamDivorce &&
          this.$storeBourse.editedItem.tuteur ==
            this.$storeCatalogue.DataId.Non)
      );
    },
    ShowSituationPro() {
      return !(
        this.$storeBourse.editedItem.statutParentTuteur ==
          this.$storeCatalogue.SituationFamDivorce &&
        this.$storeBourse.editedItem.tuteur == this.$storeCatalogue.DataId.Non
      );
    },
    ShowRetraiteActif(){
      return (this.$storeBourse.editedItem.situationPro === this.$storeCatalogue.DataId.SituationProRetraiteActif);
    },
    DateRetraiteFormated() {
      return this.$storeBourse.FormatDate(
        this.$storeBourse.editedItem.dateDepartRetraite
      );
    },
    IsReadOnlyTuteur() {
      return (
        ((this.$storeBourse.editedItem.parente ==
          this.$storeCatalogue.DataId.ParenteMere ||
          this.$storeBourse.editedItem.parente ==
            this.$storeCatalogue.DataId.ParentePere) &&
          this.$storeBourse.editedItem.statutParentTuteur ==
            this.$storeCatalogue.SituationFamMarie) ||
        this.$storeBourse.DonneesFormulaireEC.readOnly
      );
    },
    MinDateRetraite() {
      return moment(String(new Date()))
        .subtract(70, "year")
        .format("YYYY-MM-DD");
    },
    MaxDateRetraite() {
      return moment(String(new Date())).format("YYYY-MM-DD");
    },
  },
  methods: {
    ShowEmployeur(secteurActivite) {
      return (
        !(
          this.$storeBourse.editedItem.situationPro ==
            this.$storeCatalogue.SituationProNonActif ||
          secteurActivite ==
            this.$storeCatalogue.SecteurLiberale ||
          secteurActivite ==
            this.$storeCatalogue.SecteurAutoEntrepreneur ||
          (this.$storeBourse.editedItem.statutParentTuteur ==
            this.$storeCatalogue.SituationFamDivorce &&
            this.$storeBourse.editedItem.tuteur ==
              this.$storeCatalogue.DataId.Non)
        ) &&
        !(
          this.$storeBourse.editedItem.tuteur ==
            this.$storeCatalogue.DataId.Oui &&
          secteurActivite ==
            this.$storeCatalogue.SecteurAgricole
        ) &&
        !(
          this.$storeBourse.editedItem.tuteur ==
            this.$storeCatalogue.DataId.Oui &&
          secteurActivite ==
            this.$storeCatalogue.SecteurInformel
        )
      );
    },
    ShowProfession(secteurActivite) {
      return (
        !(
          this.$storeBourse.editedItem.situationPro ==
            this.$storeCatalogue.SituationProNonActif ||
          (this.$storeBourse.editedItem.statutParentTuteur ==
            this.$storeCatalogue.SituationFamDivorce &&
            this.$storeBourse.editedItem.tuteur ==
              this.$storeCatalogue.DataId.Non)
        ) &&
        !(
          this.$storeBourse.editedItem.tuteur ==
            this.$storeCatalogue.DataId.Oui &&
          secteurActivite ==
            this.$storeCatalogue.SecteurAgricole
        )
      );
    },
    SituationHandicapChange(){
      if(this.$storeBourse.editedItem.situationHandicap === this.$storeCatalogue.DataId.Non){
        this.$storeBourse.editedItem.natureHandicap = [];
      }
    },
    Ajouter() {
      this.$storeBourse.editedItem = Object.assign({}, this.blankItem);
      this.AffecterAutreRevenu();
    },
    AffecterAutreRevenu() {
      this.$storeBourse.editedItem.autreRevenuDto.situationFamiliale =
        this.$storeBourse.editedItem.idCrypte;
      this.$storeBourse.editedItem.autreRevenuDto.candidatureBourseFirsi =
        this.$storeBourse.DonneesFormulaireEC.id;
      this.$storeBourse.editedItem.autreRevenuDto.financementPropriete =
        this.$storeCatalogue.DataId.AutreRevenu;
      this.$storeBourse.editedItem.autreRevenuDto.personneConcernee =
        this.$storeCatalogue.PersonneConcerne(
          this.$storeBourse.editedItem.parente
        );
    },
    editItem(item) {
      // Récupère l'item à éditer et l'affecte à editItem local pour remplir les rubriques du formulaire popup.
      this.$storeBourse.editItem(
        item,
        this.$storeBourse.DonneesFormulaireEC.listeSituationsFamiliale
      );
      this.AffecterAutreRevenu();
      // ouvre le popup
      this.dialog = true;
    },
    deleteItem(item) {
      if (confirm("Etes-vous sûr de vouloir supprimer cette ligne?")) {
        this.$storeBourse.DonneesFormulaireEC.listeSituationsFamiliale =
          this.$storeBourse.deleteItem(
            item,
            this.$storeBourse.DonneesFormulaireEC.listeSituationsFamiliale
          );
      }
    },
    close() {
      // RAZ des champs du formulaire
      this.$refs.form.resetValidation();

      // ferme le popup
      this.dialog = false;
      this.$storeBourse.close(this.blankItem);

      this.$storeCommun.CountNombreTuteurs(
        this.$storeBourse.DonneesFormulaireEC.listeSituationsFamiliale
      );
    },
    save() {
      // validation du formulaire
      this.$refs.form.validate();
      if (!this.valid) {
        return;
      }

      this.AffecterAutreRevenu();
      this.$storeBourse.save(
        this.$storeBourse.DonneesFormulaireEC.listeSituationsFamiliale
      );
      this.$storeCommun.CountNombreTuteurs(
        this.$storeBourse.DonneesFormulaireEC.listeSituationsFamiliale
      );

      // on appelle close pour raz l'item local + fermer le popup
      this.close();
    },

    // méthodes on change
    provinceChange() {
      this.$storeBourse.editedItem.regionMaroc =
        this.$storeCatalogue.GetParentId(
          this.$storeCatalogue.Province,
          this.$storeBourse.editedItem.provinceMaroc
        );
    },

    departementChange() {
      this.$storeBourse.editedItem.regionFrance =
        this.$storeCatalogue.GetParentId(
          this.$storeCatalogue.DepartementFrance,
          this.$storeBourse.editedItem.departementFrance
        );
    },
    parenteChange() {
      if (
        this.$storeBourse.editedItem.parente !=
        this.$storeCatalogue.DataId.ParenteTuteur
      ) {
        this.$storeBourse.editedItem.statutParentTuteur = "";
        this.$storeCatalogue.StatutParentTuteurAffiche =
          this.$storeCatalogue.GetByCode(
            this.$storeCatalogue.StatutParentTuteur,
            "P"
          );
      } else {
        this.$storeCatalogue.StatutParentTuteurAffiche =
          this.$storeCatalogue.StatutParentTuteur;
      }
    },
    statutParentTuteurChange() {
      if (
        this.$storeBourse.editedItem.statutParentTuteur ==
        this.$storeCatalogue.SituationFamDecede
      ) {
        this.$set(this.$storeBourse.editedItem, 'tuteur', null);
      }
      if (
        this.$storeBourse.editedItem.statutParentTuteur ==
        this.$storeCatalogue.SituationFamMarie
      ) {
        // utilisation de set pour résoudre le problème de réactivité.
        this.$set(this.$storeBourse.editedItem, 'tuteur', this.$storeCatalogue.DataId.Oui);
      }
    },
    DisableTypeOrganisme(secteurActivite){
      if (secteurActivite == this.$storeCatalogue.SecteurFonctionnaire) {
        return true;
      } 
      else if (secteurActivite == this.$storeCatalogue.SecteurSalarie) {
        return true;
      } 
      else {
        return false;
      }
    },
    secteurActiviteProChange(secteur, retraite) {
      if(retraite){
        this.ShowTypeOrganismeRetraite = false;
        this.$set(this.$storeBourse.editedItem,'typeOrganismeRetraite', null);
        this.$set(this.$storeBourse.editedItem,'secteurProfessionnelleRetraite', null);
      }else{
        this.ShowTypeOrganismeActif = false;
        this.$set(this.$storeBourse.editedItem,'typeOrganisme', null);
        this.$set(this.$storeBourse.editedItem,'secteurActivitePro', null);
      }

      let typeOrga = null;
      if(secteur === this.$storeCatalogue.SecteurFonctionnaire){
        typeOrga = this.$storeCatalogue.DataId.TypeOrganismePublic;
      }
      else if(secteur === this.$storeCatalogue.SecteurSalarie){
        typeOrga = this.$storeCatalogue.DataId.TypeOrganismePrive;
      }

      if(typeOrga !== null){
        if(retraite){
          this.ShowTypeOrganismeRetraite = true;
          this.$set(this.$storeBourse.editedItem,'typeOrganismeRetraite', typeOrga);
          this.$set(this.$storeBourse.editedItem,'secteurProfessionnelleRetraite', secteur);
        }else{
          this.ShowTypeOrganismeActif = true;
          this.$set(this.$storeBourse.editedItem,'typeOrganisme', typeOrga);
          this.$set(this.$storeBourse.editedItem,'secteurActivitePro', secteur);
        }
      }
    },
    situationProChange() {
      this.$storeBourse.editedItem.typeOrganisme = null;
      this.$storeBourse.editedItem.secteurActivitePro = null;
      this.$storeBourse.editedItem.employeur = null;
      this.$storeBourse.editedItem.profession = null;
      this.$storeBourse.editedItem.typeOrganismeRetraite = null;
      this.$storeBourse.editedItem.secteurActiviteProRetraite = null;
      this.$storeBourse.editedItem.employeurRetraite = null;
      this.$storeBourse.editedItem.professionRetraite = null;
    },
  },
};
</script>
<style scoped src="@/assets/css/DemandeBourse.css"></style>
